import React                    from 'react';
import {
	Col,
	Row
}                               from 'reactstrap';
import TrackerNav
								from '../components/TrackerNav/TrackerNav';
import PizzaDetails
								from '../components/PizzaTracker/PizzaDetails';
import CardHeader
								from 'reactstrap/es/CardHeader';
import CardBody
								from 'reactstrap/es/CardBody';
import Card
								from 'reactstrap/es/Card';
import Button
								from 'reactstrap/es/Button';
import { NotificationService }  from '../services';
import NotificationAlert
								from 'react-notification-alert/index';
import { pizzaDeliveryService } from '../services/pizza.delivery.service';

class PizzaTrackerConfig extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			selected: null,
			pipedrive: null,
			salesAreas: null,
			allConfigs: null,
		}
	}

	changeWorkflow = (id) => {
		this.setState({selected: id})
	}

	componentDidMount() {
		pizzaDeliveryService.getPipelinesAndStages().then(response => {
			this.setState({pipedrive: response.Data})
		})
		.catch(err => {
			this.refs.notificationAlert.notificationAlert(NotificationService.notify('tc', 3, "Error: " + err))
		});
		this.refreshConfigs();
	}

	refreshConfigs = () => {
		pizzaDeliveryService.getActiveConfigs().then(response => {
			this.setState({allConfigs: response.Data})
		})
		.catch(err => {
			this.refs.notificationAlert.notificationAlert(NotificationService.notify('tc', 3, "Error: " + err))
		});
	}

	addNewConfig = () => {
		pizzaDeliveryService.addNewConfig().then(response => {
			this.setState({allConfigs: response.Data})
		})
		.catch(err => {
			this.refs.notificationAlert.notificationAlert(NotificationService.notify('tc', 3, "Error: " + err))
		});
	}

	render() {
		const {selected, pipedrive, allConfigs} = this.state;
		var config = null;
		if (selected) {
			config = allConfigs.find(data => {
				return data.ID === selected;
			});
		}

		return (
			<>
				<NotificationAlert ref="notificationAlert" />
				<div className="content">
					<Row>
						<Col xs="12">
							<Button onClick={this.addNewConfig}>Add New Config</Button>
						</Col>
					</Row>
					<Row>
						<Col xs="12">
							<TrackerNav config={allConfigs} onClickHandler={this.changeWorkflow}/>
						</Col>
					</Row>
					{config && <PizzaDetails onSaveCallback={this.refreshConfigs} pipedrive={pipedrive} config={config}/>}
				</div>
			</>
		)
	}
}

export default PizzaTrackerConfig;
